import React, { Component } from "react";
import Button from "./Button";

class Buttons extends Component {
  buttons = [];
  state = {
    triggered: false,
  };

  sendButtonResponse = (message) => {
    this.props.onSubmitButtonResponse(message);
    this.setState({ triggered: true });
  };

  render() {
    return (
      <div className={`buttons ${this.state.triggered ? "triggered" : ""}`}>
        {this.props.buttons.length > 0 &&
          this.props.buttons.map((button, index) => (
            <Button
              key={index}
              href={button.type==='LINK_BUTTON' ? button.value : null}
              title={button.title}
              type={button.type}
              onSubmitButtonResponse={(message) =>
                this.sendButtonResponse(message)
              }
            />
          ))}
      </div>
    );
  }
}

export default Buttons;
